export const MISSION_PRE_SELECT_FETCH = 'MISSION_PRE_SELECT_FETCH'
export const MISSION_PRE_SELECT_SUCCEEDED = 'MISSION_PRE_SELECT_SUCCEEDED'
export const MISSION_PRE_SELECT_FAILED = 'MISSION_PRE_SELECT_FAILED'
export const MISSION_ACCEPT_FETCH = 'MISSION_ACCEPT_FETCH'
export const MISSION_REVIEW_FETCH = 'MISSION_REVIEW_FETCH'
export const MISSION_REVIEW_SUCCESS_FETCH = 'MISSION_REVIEW_SUCCESS_FETCH'
export const MISSION_ACCEPT_SUCCEEDED = 'MISSION_ACCEPT_SUCCEEDED'
export const MISSION_ACCEPT_FAILED = 'MISSION_ACCEPT_FAILED'
export const MISSION_HISTORY_SUCCEDED = 'MISSION_HISTORY_SUCCEDED'
export const MISSION_HISTORY_FAILED = 'MISSION_HISTORY_FAILED'

export const MISSION_ANSWER_INIT = 'MISSION_ANSWER_INIT'
export const MISSION_ANSWER_DONE = 'MISSION_ANSWER_DONE'
export const MISSION_ANSWER_DONE_SUCCEEDED = 'MISSION_ANSWER_DONE_SUCCEEDED'
export const MISSION_ANSWER_DONE_FAILED = 'MISSION_ANSWER_DONE_FAILED'
export const PROCESS_MISSION_ANSWER_DONE = 'PROCESS_MISSION_ANSWER_DONE'
export const PAGE_ANSWERED = 'PAGE_ANSWERED'
export const MISSION_ALERT_SHOWED = 'MISSION_ALERT_SHOWED'
export const NEW_TRY_STARTED = 'NEW_TRY_STARTED'
export const RESET_SELECTED_MISSION = 'RESET_SELECTED_MISSION'
export const PARTIAL_MISSION_ANSWER_DONE = 'PARTIAL_MISSION_ANSWER_DONE'

export const newTryStarted = () =>
  ({ type: NEW_TRY_STARTED })

export const preSelectMission = ({ id, dependants }) =>
  ({ type: MISSION_PRE_SELECT_FETCH, payload: { id, dependants } })

export const missionPreSelectSucceeded = data =>
  ({ type: MISSION_PRE_SELECT_SUCCEEDED, payload: data })

export const missionPreSelectFailed = data =>
  ({ type: MISSION_PRE_SELECT_FAILED, payload: data })

export const acceptMission = ({ id }) =>
  ({ type: MISSION_ACCEPT_FETCH, payload: { id } })

export const reviewMission = ({ id: missionId }, { id: answerId }) =>
  ({ type: MISSION_REVIEW_FETCH, payload: { missionId, answerId } })

export const reviewMissionSuccess = payload =>
  ({ type: MISSION_REVIEW_SUCCESS_FETCH, payload })

export const acceptMissionSucceeded = data =>
  ({ type: MISSION_ACCEPT_SUCCEEDED, payload: data })

export const acceptMissionFailed = data =>
  ({ type: MISSION_ACCEPT_FAILED, payload: data })

export const missionAnswerInit = () =>
  ({ type: MISSION_ANSWER_INIT })

export const pageAnswered = payload =>
  ({ type: PAGE_ANSWERED, payload })

export const missionAnswered = answers =>
  ({ type: MISSION_ANSWER_DONE, payload: answers })

export const partialMissionAnswered = answers =>
  ({ type: PARTIAL_MISSION_ANSWER_DONE, payload: answers })

// { mission: { id, image_url, short_description, credits, experience, state },
//   new_medals, new_titles, user: { ... } }
export const missionAnsweredSucceeded = (payload) => {
  const mission_credits = payload.mission.credits
  const medals_credits = payload.new_medals.map(
    m => m.credits).reduce((x, y) => x + y, 0)
  const credits_to_add = mission_credits + medals_credits
  const experience_to_add = payload.mission.experience
  return {
    type: MISSION_ANSWER_DONE_SUCCEEDED,
    payload: {
      ...payload,
      credits_to_add,
      experience_to_add,
    },
  }
}

export const missionAnsweredFailed = data =>
  ({ type: MISSION_ANSWER_DONE_FAILED, payload: data })

export const processMissionAnswered = answers =>
  ({ type: PROCESS_MISSION_ANSWER_DONE, payload: answers })

export const missionAlertShowed = () =>
  ({ type: MISSION_ALERT_SHOWED })

export const resetSelectedMission = () =>
  ({ type: RESET_SELECTED_MISSION })

export const missionHistorySucceeded = history =>
  ({ type: MISSION_HISTORY_SUCCEDED, payload: history })

export const missionHistoryFailed = () =>
  ({ type: MISSION_HISTORY_FAILED })



// WEBPACK FOOTER //
// ./src/actions/missions.jsx